var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb flat text-center"},_vm._l((_vm.items),function(item,index){return _c('a',{key:index,class:{ active: item.active },attrs:{"href":item.link}},[_vm._v(_vm._s(item.text))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }